module.exports = __webpack_public_path__ + "img/MoonSword 1.5a916872.png";